import React from 'react';
import ReactPhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import fr from 'react-phone-input-2/lang/fr.json';
import Radium from 'radium';
import { cleanPhoneNumber } from 'utils/phone';

const styles = {
	customlabel: {
		fontSize: '0.8em',
		marginTop: 5,
		marginLeft: 2,
	},
	crossRequired: {
		color: '#c5190e',
		fontSize: '1em',
		position: 'relative',
		bottom: 1,
		left: 3,
	},
};

const inputStyle = (error, disabled) => ({
	width: '100%',
	height: 38,
	border: '1px solid rgba(34,36,38,.15)',
	transition: 'box-shadow .1s ease,border-color .1s ease',
	background: error ? '#fff6f6' : '#fff',
	borderColor: error ? '#e0b4b4' : 'rgba(34,36,38,.15)',
	color: error ? '#9f3a38' : '',
	opacity: disabled ? '0.5' : '1',
	':focus': {
		border: '1px solid #85b7d9',
	},
});

const errorStyle = {
	color: '#dc0000',
	fontSize: '0.7em',
};

const InputPhone = ({
	field: { name, value },
	form: { errors, touched, setFieldValue },
	id,
	label,
	className,
	...props
}) => {
	return (
		<div>
			<div style={styles.customlabel}>
				{props.customlabel}
				{props.required && <span style={styles.crossRequired}>*</span>}
			</div>
			<ReactPhoneInput
				value={cleanPhoneNumber(value)}
				country={process.env.REACT_APP_SELECTED_PHONES}
				preferredCountries={process.env.REACT_APP_PROMOTED_PHONES.split(' ')}
				preserveOrder={['preferredCountries']}
				localization={fr}
				inputProps={{
					name: name,
					id: id,
					autoComplete: 'off',
				}}
				onChange={(val) => setFieldValue(name, cleanPhoneNumber(val, true))}
				inputStyle={inputStyle(touched[name] && errors[name], props.disabled)}
				{...props}
			/>
			{touched[name] && errors[name] && (
				<div style={errorStyle}>{errors[name]}</div>
			)}
		</div>
	);
};

export default Radium(InputPhone);
